export default "__VITE_ASSET__Oj7S1p9i__"